<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <div class="two-factor-authentication">
        <h2 class="title">Autenticação de Dois Fatores</h2>
        <p class="instruction">Abra o seu aplicativo do Google Authenticator e insira o código de verificação do Pedbot</p>
        <vs-input id="inputTwoFactor" v-model="googleSecret" class="w-full" placeholder="Código de 6 digitos" required type="text" @keyup.enter="validate"/>
        <vs-button class="button w-full" color="primary" @click="validate">Enviar Código</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { empty } from '@/utils';

export default {
  data() {
    return {
      googleSecret: ''
    }
  },
  computed: {
    loginData() {
      return this.$store.state.global.loginData;
    },
  },
  methods: {
    async validate() {
      const numericRegex = /^[0-9]+$/;
      if (!numericRegex.test(this.googleSecret)) {
        this.$vs.notify({
          title: 'Erro',
          text: 'O código deve ser apenas numérico.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });

        return;
      }

      try {
        if (this.googleSecret) {
          // O token de sessão (JWT) válido para validar o 2FA vive apenas em loginData,
          // gerado neste login. Se loginData estiver vazio (ex.: reload da página), NÃO
          // reutilizar o accessToken do localStorage — ele é resíduo de uma sessão anterior
          // e pode estar expirado ("Token is Expired"). Nesse caso, voltar para o login.
          if (empty(this.loginData)) {
            this.clearData();
            this.redirectToLogin();
            return;
          }

          const token  = this.loginData.access_token;
          const email  = this.loginData.user.email;
          const role   = this.loginData.user.role.display_name;
          const userId = this.loginData.user.id;

          const data  = {
            'google2fa_secret': this.googleSecret,
            'identify': 1,
            'role': role,
            'email': email
          };

          await this.$store.dispatch('activityTwoFactor', {
            id: userId,
            token: token,
            alterObject: data,
          }).then(async () => {
            // 2FA validado: estabelece a sessão com o token fresco deste login,
            // sobrescrevendo qualquer accessToken antigo que tenha sobrado no localStorage.
            await this.login();

            this.$vs.notify({
              title: 'Token validado com sucesso!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });

            this.$store.dispatch('fetchPermissions', {
              email: email,
              token: token
            }).then(responseData => {
              const permissions = responseData.data;
              localStorage.removeItem('permissions');
              localStorage.setItem('permissions', JSON.stringify(permissions));
              this.$router.push('/').then(() => window.location.reload());
            }).catch((error) => {
              console.error('Erro ao buscar permissões', error);
            });
          }).catch((error) => {
            console.error('Erro ao validar código de 2 fatores', error);
            this.$vs.notify({
              title: 'Token inválido.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
            });
          });
        }
      } catch (error) {
        console.error('Ocorreu um erro ao validar a chave secreta:', error);
        this.$vs.notify({
          title: 'Ocorreu um erro ao validar seu token.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
      }
    },
    redirectToLogin() {
      this.$router.push('/login');
    },
    async login() {
      this.$store.commit('setEmail', { email: this.loginData.user.email });
      this.$store.commit('setToken', { token: this.loginData.access_token });
      this.$store.commit('setOrigin', { value: this.loginData.origin_backoffice });
      this.$store.commit('setPermissionRoutes', { routes: this.loginData.has_permission_routes });

      await this.$store.dispatch('getAllUsers');
      await this.$store.dispatch('userInfo');
      await this.$store.dispatch('setName');
      await this.$store.dispatch('layout/navMenuItems');

      this.$store.commit('setLoginData', {});
    },
    async clearData() {
      this.$store.commit('setLoginData', {});
      await this.$store.dispatch('layout/clearNavMenuItems');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('email');
      localStorage.removeItem('name');
      localStorage.removeItem('permissions');
      localStorage.removeItem('twoFactor');
      localStorage.removeItem('permissionRoutes');
      localStorage.removeItem('originBackoffice');
      localStorage.removeItem('accessToken');
    },
  },
  mounted() {
    if (empty(this.loginData) && empty(localStorage.getItem('accessToken'))) {
      this.clearData();
      setTimeout(() => this.redirectToLogin(), 1000);
      return;
    }
  },
}

</script>

<style>
.two-factor-authentication {
  max-width: 500px;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  border: 0.5px solid #ccc;
  border-radius: 8px;
  background-color: #efefef;
  border-color: #716e6e;
}

.title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.form {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 16px;
  margin-bottom: 8px;
}

#inputTwoFactor {
  padding: 8px;
  font-size: 16px;
  margin-bottom: 16px;
  border: 1px solid #716e6e;
  border-radius: 4px;
}

.button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.button:hover {
  background-color: #0056b3;
}

.instruction {
  text-align: center;
  color: black;
  font-weight: 430;
  margin-bottom: 40px;
}
</style>